import { AssetPermissionsTableProps } from '../AssetPermissionsTable'
import { DropdownState } from '../../Dropdown/Dropdown.types'

export enum DropdownItem {
  OWNER = 'OWNER',
  CREATOR = 'CREATOR',
  EDITOR = 'EDITOR',
  VIEWER = 'VIEWER',
  REMOVE = 'REMOVE'
}

export const DROPDOWN_ITEM_LABELS: Record<string, string> = {
  [DropdownItem.OWNER]: 'Owner',
  [DropdownItem.CREATOR]: 'Owner',
  [DropdownItem.EDITOR]: 'Editor',
  [DropdownItem.VIEWER]: 'Viewer',
  [DropdownItem.REMOVE]: 'Remove'
}

export enum SubdomainDropdownItem {
  SHARED = 'SHARED',
  REMOVE = 'REMOVE'
}

export const SUBDOMAIN_DROPDOWN_ITEM_LABELS: Record<string, string> = {
  [SubdomainDropdownItem.SHARED]: 'Shared',
  [SubdomainDropdownItem.REMOVE]: 'Remove'
}

export type OnNewItemSelected = (item: DropdownItem | SubdomainDropdownItem) => void

export interface PermissionsDropdownState
  extends Pick<AssetPermissionsTableProps, 'trackingClickPermissionDropdown' | 'assetId'>,
    DropdownState {
  showMobileStyles: boolean
  itemsShown: DropdownItem[]
  onNewItemSelected: OnNewItemSelected
  itemSelected: DropdownItem
  whiteLabelItemsShown: SubdomainDropdownItem[]
  whiteLabelItemSelected: SubdomainDropdownItem
}
